import styled from 'styled-components'

const NavigationListStyled = styled.ul`
  list-style: none;
`

export default NavigationListStyled
